// extracted by mini-css-extract-plugin
export default {"logContainer":"hG66Ekb2hv","buttonsOverlay":"bkRMi8tfZn","iframeWrapper":"PR1wtnML5P"};